import { render, staticRenderFns } from "./PurchaseStatusDetails.vue?vue&type=template&id=0507d333"
import script from "./PurchaseStatusDetails.vue?vue&type=script&lang=js"
export * from "./PurchaseStatusDetails.vue?vue&type=script&lang=js"
import style0 from "./PurchaseStatusDetails.vue?vue&type=style&index=0&id=0507d333&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports